import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

const DATA_URL = "static/data.json";
const state = {
  isMobile: false,
  popup: -1,
  popupContent: -1,
  slideshows: [
    {
      id: "1",
      numberOfImage: 3,
      path: "images/slideshow1/",
    },
  ],
  content: [],
  config: {
    has_intro_audio: false,
  },
  contentLoaded: false,
};

const mutations = {
  SET_POPUP(state, val) {
    state.popup = val;
    if (val > 0) {
      let newContent = -1;
      console.log(state);
      state.content.forEach((contentItem, idx) => {
        if (contentItem.id == val + "") {
          newContent = idx;
        }
      });
      state.popupContent = newContent;
    } else {
      state.popupContent = -1;
    }
  },
  SET_CONTENT(state, data) {
    state.content = data.content;
    state.config = data.config;
    state.contentLoaded = true;
  },
  SET_IS_MOBILE(state, val) {
    state.isMobile = val;
  },
};

const actions = {
  set_popup({ commit }, val) {
    commit("SET_POPUP", val);
  },
  load_json({ commit }) {
    axios
      .get(DATA_URL)
      .then((response) => {
        commit("SET_CONTENT", response.data);
      })
      .catch((error) => {
        console.log("could not load content", error);
      });
  },
  set_is_mobile({ commit }, val) {
    commit("SET_IS_MOBILE", val);
  },
};

Vue.use(Vuex);

export default new Vuex.Store({
  state,
  mutations,
  actions,
  strict: process.env.NODE_ENV !== "production",
});
